import type { FinanceError } from '../api/financeTypes'

/** The `errors[]` entry explaining why a figure is `null` (`field: code`). A
 * field matches itself and its sub-paths (`unknown_outcome` ~ `unknown_outcome.count`). */
export function reasonFor(errors: FinanceError[] | undefined, ...fields: string[]): string | undefined {
  const e = errors?.find((x) => fields.some((f) => x.field === f || x.field.startsWith(`${f}.`) || x.field.startsWith(`${f}[`)))
  return e ? `${e.field}: ${e.code}` : undefined
}
